import React from "react";
import PropTypes from "prop-types";
import styles from './Chart.less';
import { format } from "d3-format";
import { timeFormat } from "d3-time-format";
import { scaleTime } from "d3-scale";
import { ChartCanvas, Chart } from "react-stockcharts";
import {
  BarSeries,
  OHLCSeries,
  LineSeries,
  MACDSeries
} from "react-stockcharts/lib/series";
import { XAxis, YAxis } from "react-stockcharts/lib/axes";
import {
  CrossHairCursor,
  EdgeIndicator,
  MouseCoordinateX,
  MouseCoordinateY
} from "react-stockcharts/lib/coordinates";
import i18next from 'i18next';
import { discontinuousTimeScaleProvider } from "react-stockcharts/lib/scale";
import {
  MovingAverageTooltip,
  MACDTooltip
} from "react-stockcharts/lib/tooltip";
import {
  ema,
  macd,
  change,
  elderImpulse
} from "react-stockcharts/lib/indicator";
import { fitWidth } from "react-stockcharts/lib/helper";
import { last } from "react-stockcharts/lib/utils";
import CustomOHLCTooltip from './CustomOHLCTooltip';
import { HoverTooltip } from "react-stockcharts/lib/tooltip";
import CustomOHLCSeries from './CustomOHLCSeries';
import config from './../../config';
import { connect } from 'react-redux';
import * as commonActions from './../../actions/commonActions';
const macdAppearance = {
  stroke: {
    macd: "#FF0000",
    signal: "#00F300"
  },
  fill: {
    divergence: "#4682B4"
  }
};
@connect(
  state => ({
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
  language:state.dashboardRoot.commonReducer.language
}),
{ ...commonActions})

class OHLCChartWithElderImpulseIndicator extends React.Component {
  componentDidMount() {
    this.node.subscribe("zoomlistner", { listener: this.handleEvents })
  }
  componentWillUnmount() {
    // this.node.unsubscribe("zoomlistner")
  }
  handleEvents = (type, moreProps, state) => {
    try{
      if (type === "zoom" || type === "panend") {
        if (this.props.onZoomEvent) {
          this.props.onZoomEvent(moreProps.xScale.domain());
        }
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleEvents', component:"OHLCChartWithElderImpulseIndicator"});
    }
  }
  render() {
    const changeCalculator = change();

    const ema12 = ema()
      .id(1)
      .options({ windowSize: 12 })
      .merge((d, c) => {
        d.ema12 = c;
      })
      .accessor(d => d.ema12);

    const macdCalculator = macd()
      .options({
        fast: 12,
        slow: 26,
        signal: 9
      })
      .merge((d, c) => {
        d.macd = c;
      })
      .accessor(d => d.macd);

    const elderImpulseCalculator = elderImpulse()
      .macdSource(macdCalculator.accessor())
      .emaSource(ema12.accessor());

    const { type, data: initialData, width, ratio, decimals } = this.props;
    const calculatedData = elderImpulseCalculator(
      macdCalculator(ema12(changeCalculator(initialData)))
    );
    const xScaleProvider = discontinuousTimeScaleProvider.inputDateAccessor(
      d => d && d.date ? d.date : ''
    );
    const { data, xScale } = xScaleProvider(
      calculatedData
    );
    const xAccessor = (d)=> {
      return d && d.date ? d.date : '';
    }
    // const start = xAccessor(last(data));
    // const end = xAccessor(data[Math.max(0, data.length - 150)]);
    // const start = xAccessor(data[0]);
    // const end = xAccessor(data[data.length - 1]);
    const xExtents = data.length > 4 ?  [ new Date(data[0].TradeDate-(86400000*3)), new Date(data[data.length - 1].TradeDate+(86400000*3)) ] : ( data.length === 4 ? [ new Date(data[0].TradeDate-(86400000*4)), new Date(data[data.length - 1].TradeDate+(86400000*4)) ] : [ new Date(data[0].TradeDate-(86400000*12)), new Date(data[data.length - 1].TradeDate+(86400000*12)) ] );
    // const xExtents = [
    //   new Date(xAccessor(data[0]) - 1000*60*60*24*4),
    //   new Date(xAccessor(data[data.length - 1]) + 1000*60*60*24*4)
    // ];
    var margin = {
        top: 20,
        right: 0,
        bottom: 20,
        left: 70
    };
    var height = (this.props.height > 400 ? this.props.height : 300 ) - margin.top - margin.bottom;
    var gridHeight = height - margin.top - margin.bottom;
    var gridWidth = width - margin.left - margin.right;
    var color='#000';
    var axisColor='#000';
    var dataLength = 0;
    if (this.props.data.length !== 0) {
      dataLength = Number(this.props.data[this.props.data.length-1].open).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}).length;
    }
    let ohlcTooltipOrigin = [
        this.props.width< 517 ? -40 : (this.props.language != 'AR' ? 0 : 500),
        -38
      ];
    const displayTextsZoom = {
      d: "D",
      o: "O",
      h: "H",
      l: "L",
      c: "C",
      v: "V",
      na: "n/a"
    };
    const displayTexts = {
      d: "Date",
      o: "O",
      h: "H",
      l: "L",
      c: "C",
      v: "V",
      na: "n/a"
    };
    var yGrid =  {
        innerTickSize: -1 * gridWidth,
        tickStrokeDasharray: 'Dot',
        tickStrokeOpacity: 0.2,
        tickStrokeWidth: 1,
        stroke: axisColor,
        tickStroke:color
    };
    var xGrid = {
        tickStroke:color,
        stroke: axisColor
    } ;
    var yGridDark =  {
        innerTickSize: -1 * gridWidth,
        tickStrokeDasharray: 'Dot',
        tickStrokeOpacity: 0.4,
        tickStrokeWidth: 2,
        stroke: "#b2b1ae",
        tickStroke: "#b2b1ae"
    };
    var xGridDark = {
        stroke: "#b2b1ae",
        tickStroke: "#b2b1ae"
    } ;

    let tickTimeFormat = d3.time.format.multi([
      // [":%Ss", function(d) { return d.getSeconds(); }],
      // ["%H:%M", function(d) { return d.getHours() || d.getMinutes(); }],
      //["%d%b %Y", function(d) { return dateFormatter(new Date(d));}],
    //   ["%a %d", function(d) { return d.getDay() <= 6 && d.getDate() != 1; }],
        ["%d %b", function(d) { return true; }],
       ["%d %b", function(d) { return d.getDate() != 1; }],
    //  ["%b", function(d) { return d && true; }]
      // ["%Y", function() { return true; }]
    ]);;

    var tickFormatFn = function(d) {
        return tickTimeFormat(d);
    };
    var numberFormat = function(d) {
      return d.toLocaleString(navigator.language,{ minimumFractionDigits:decimals,maximumFractionDigits:decimals});
    }
    let tooltipContent = ({ currentItem }) => {
      if (this.props.language == 'AR') {
        return {
          x: (Number(currentItem.open).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals})) + ': '+i18next.t("O"),
          y: [{label: Number(currentItem.high).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}), value: i18next.t("H").split(':')[0]}, {label: Number(currentItem.low).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}), value: i18next.t("L").split(':')[0]}, {label: Number(currentItem.close).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}), value: i18next.t("C").split(':')[0]}]
          .filter(line => line.value)
        };
      }
      else {
        return {
          x: (i18next.t("open")) + ': '+Number(currentItem.open).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}),
          y: [{label: i18next.t("high").split(':')[0], value: '  '+Number(currentItem.high).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals})}, {label: i18next.t("low").split(':')[0], value: '   '+Number(currentItem.low).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals})}, {label: i18next.t("close").split(':')[0], value: Number(currentItem.close).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals})}]
          .filter(line => line.value)
        };
      }
    }

    const zoomLevel = this.props.zoomLevel ? this.props.zoomLevel.map((item) => new Date(item)) : xExtents;
    return (
      <ChartCanvas
        height={gridHeight}
        width={width}
        ratio={ratio}
        margin={margin}
        type={type}
        seriesName="MSFT"
        //clamp={'right'}
        pointsPerPxThreshold={0.5} //max zoom-out
        data={data}
        xScale={scaleTime()}
        xAccessor={xAccessor}
        displayXAccessor={xAccessor}
        ref={node => { this.node = node; } }
        xExtents = {zoomLevel || xExtents}
      >
        <Chart
          id={1}
          yExtents={d => [d.high + Math.pow(10, -1 * (decimals-1)), d.low - Math.pow(10, -1 * (decimals-1))]}
          // padding={{ top: 10, bottom: 10 }}
        >
          { this.props.selectedCssColor==="DR" ?
            <XAxis axisAt="bottom" orient="bottom" outerTickSize={0} ticks={data.length < 5 ? 4 : 5} tickFormat={tickFormatFn} {...xGrid}/>
            :
            <XAxis axisAt="bottom" orient="bottom" outerTickSize={0} ticks={data.length < 5 ? 4 : 5} tickFormat={tickFormatFn} {...xGridDark}/>
          }
          { this.props.selectedCssColor==="DR" ?
          <YAxis axisAt="left" orient="left" tickFormat={numberFormat} {...yGridDark} zoomEnabled={false}/>
          :
          <YAxis axisAt="left" orient="left" tickFormat={numberFormat} {...yGrid} zoomEnabled={false}/>
        }

          <CustomOHLCSeries
            stroke={d => (d.open - d.close) <= 0 ? config.increaseRateColor : config.decreaseRateColor}
          />

          <CustomOHLCTooltip
            forChart={1}
            fontSize={13}
            className={this.props.language != 'AR' ? `${styles.historicalToopTip}`:`${styles.historicalToopTip} chartTimeHead`}
            origin={ohlcTooltipOrigin}
            ohlcFormat={decimals}
            lastPointFromGraph={data[data.length-1]}
            displayTexts={this.props.width < 517 ? displayTextsZoom : displayTexts}
            styleObj = {this.props.styleObj}
          />
          <HoverTooltip
            tooltipContent={tooltipContent}
            fontSize={13}
            bgfill={this.props.selectedThemes.tooltipHoverBg}
            fill={this.props.selectedThemes.tooltipHoverBg}
            fontFill={this.props.selectedThemes.tooltipHoverClr}
            stroke={this.props.selectedThemes.tooltipHoverClr}
          />
        </Chart>
      </ChartCanvas>
    );
  }
}

OHLCChartWithElderImpulseIndicator.propTypes = {
  data: PropTypes.array.isRequired,
  width: PropTypes.number.isRequired,
  ratio: PropTypes.number.isRequired,
  type: PropTypes.oneOf(["svg", "hybrid"]).isRequired,
  onZoomEvent: PropTypes.func,
  zoomLevel: PropTypes.array
};

OHLCChartWithElderImpulseIndicator.defaultProps = {
  type: "svg"
};
OHLCChartWithElderImpulseIndicator = fitWidth(
  OHLCChartWithElderImpulseIndicator
);

export default OHLCChartWithElderImpulseIndicator;
